import { render, staticRenderFns } from "./receivable-detail.vue?vue&type=template&id=5570ae2a"
import script from "./receivable-detail.vue?vue&type=script&lang=js"
export * from "./receivable-detail.vue?vue&type=script&lang=js"
import style0 from "./receivable-detail.vue?vue&type=style&index=0&id=5570ae2a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports